import type { HeroContent } from '../domain/landing.types'
import { ArrowIcon } from '../../../shared/ui/icons'

const muralPng = '/brand/CuervoBlanco_Mural_Semillas.png'
const muralWebp = '/brand/CuervoBlanco_Mural_Semillas-{width}.webp'
const muralAvif = '/brand/CuervoBlanco_Mural_Semillas-{width}.avif'

function srcSet(template: string) {
  return [640, 960, 1448].map((width) => `${template.replace('{width}', String(width))} ${width}w`).join(', ')
}

type HeroProps = {
  hero: HeroContent
}

export function Hero({ hero }: HeroProps) {
  return (
    <section className="hero" id="top" aria-labelledby="hero-title">
      <div className="hero__copy">
        <p className="hero__eyebrow">{hero.eyebrow}</p>
        <h1 id="hero-title">{hero.title}</h1>
        <p className="hero__description">{hero.description}</p>
        <div className="hero__actions">
          {hero.actions.map((action) => (
            <a
              key={action.href}
              className={`button ${action.isPrimary ? 'button--primary' : 'button--secondary'}`}
              href={action.href}
            >
              {action.label}
              <ArrowIcon />
            </a>
          ))}
        </div>
        <a className="scroll-cue" href="#principios" aria-label="Descubrir más contenido">
          <span className="scroll-cue__line" aria-hidden="true" />
          <span>Descubre</span>
        </a>
      </div>

      <div className="hero__art" aria-label="Mural de semillas, cacao y paisaje productivo">
        <picture>
          <source type="image/avif" srcSet={srcSet(muralAvif)} sizes="(max-width: 800px) 100vw, 56vw" />
          <source type="image/webp" srcSet={srcSet(muralWebp)} sizes="(max-width: 800px) 100vw, 56vw" />
          <img
            src={muralPng}
            width="1448"
            height="1086"
            alt="Mural de pistaches, almendras, matcha japonés y cacao con composición monumental"
            decoding="async"
            fetchPriority="high"
          />
        </picture>
        <span className="hero__art-wash" aria-hidden="true" />
      </div>
    </section>
  )
}
